import React from 'react'

const Footer = () => {
  return (
    <>
        <div className="bg-white/5 roboto text-xs flex justify-center items-center h-9 ">
          <p className='text-white/50 '>NWOSU CHIDERA - GAMEPLAY PROGRAMMER / DESIGNER</p>
        </div>
    </>
  )
}

export default Footer